import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  Dashboard as DashboardIcon, ConfirmationNumber as TicketIcon,
  Group as AgentIcon, QuestionAnswer as FaqIcon, Settings as SettingsIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate, Routes, Route } from 'react-router-dom';
import AdminSupportDashboard from '../../components/admin/support/AdminSupportDashboard';
import AdminSupportTicketList from '../../components/admin/support/AdminSupportTicketList';
import AdminSupportTicketDetail from '../../components/admin/support/AdminSupportTicketDetail';
import AdminSupportAgents from '../../components/admin/support/AdminSupportAgents';

const AdminSupportPage = () => {
  const { t } = useTranslation(['support']);
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  const handleTabChange = (_, newTab) => {
    setTab(newTab);
    const paths = ['/admin/support', '/admin/support/tickets', '/admin/support/agents'];
    navigate(paths[newTab]);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Tab icon={<DashboardIcon />} iconPosition="start" label={t('support:admin.dashboard.title')} />
        <Tab icon={<TicketIcon />} iconPosition="start" label={t('support:admin.tickets.title')} />
        <Tab icon={<AgentIcon />} iconPosition="start" label={t('support:admin.agents.title')} />
      </Tabs>

      <Routes>
        <Route index element={<AdminSupportDashboard />} />
        <Route path="tickets" element={<AdminSupportTicketList />} />
        <Route path="tickets/:id" element={<AdminSupportTicketDetail />} />
        <Route path="agents" element={<AdminSupportAgents />} />
      </Routes>
    </Box>
  );
};

export default AdminSupportPage;
